/* External */
import { useRef, useEffect } from 'react';

/* Utils */
import { shallowEqualLists } from '../utils/functions';

export default function createCachedListSelectorHook(useHook) {
  return function useCachedListSelector(...args) {
    const returnValue = useRef();
    const lastSelectedValue = useRef();

    const selectedValue = useHook(...args);

    useEffect(() => {
      lastSelectedValue.current = selectedValue;
    }, [selectedValue]);

    if (!shallowEqualLists(selectedValue, lastSelectedValue.current)) {
      returnValue.current = selectedValue;
    }

    return returnValue.current;
  };
}
